up.compiler('[data-scroll-to-anchor]', () => {
  const anchorLink = window.location.hash

  function scrollToAnchor() {
    const anchorElement = document.querySelector(anchorLink)

    anchorElement!.scrollIntoView()
  }

  function anchorAllowed() {
    return anchorLink !== null && anchorLink !== ''
  }

  if (anchorAllowed()) {
    scrollToAnchor()
  }
})
